import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectTemplatesService } from '../api/project-templates.service';
import { PROJECT_TEMPLATE_KEYS } from './queryKeys';
import type { SaveAsTemplatePayload } from '../types';

export function useSaveProjectAsTemplate(projectId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (payload: SaveAsTemplatePayload) =>
      projectTemplatesService.saveFromProject(projectId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROJECT_TEMPLATE_KEYS.byOrg(orgId ?? '') });
    },
  });
}
